import React from "react";
import "./Home.scss";
import Revenue from "../revenue/Revenue";
import ViewChart from "../viewchart/ViewChart";
import SummaryMenu from "../summarymenu/SummaryMenu";

export default function Home() {
  return (
    <div className="main-frame-home">
      <div className="frame-chart">
        <ViewChart />
      </div>
      <div className="sub-summary">
        <div className="frame-revenue">
          <Revenue />
        </div>
        <div className="frame-summary-menu">
          <SummaryMenu />
        </div>
      </div>
    </div>
  );
}
